import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { keyframes, styled } from '@mgmresorts/wcl-styled';
import React from 'react';
import { createIcon } from './createIcon.es.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var SpinnerSVG = createIcon({
  name: 'SpinnerSVG',
  width: 66,
  height: 66,
  render: function render(_ref) {
    var width = _ref.width,
        height = _ref.height;
    return /*#__PURE__*/React.createElement("svg", {
      "aria-hidden": "true",
      width: width,
      height: height,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "22 22 44 44"
    }, /*#__PURE__*/React.createElement("circle", {
      className: "Spinner__path",
      fill: "none",
      strokeWidth: "2",
      strokeLinecap: "round",
      cx: "44",
      cy: "44",
      r: "20.2"
    }));
  }
});
var spinDuration = 1.3;
var rotatorKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var colorsKeyframes = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    stroke: currentColor;\n  }\n  25% {\n    stroke: currentColor;\n  }\n  50% {\n    stroke: currentColor;\n  }\n  75% {\n    stroke: currentColor;\n  }\n  100% {\n    stroke: currentColor;\n  }\n"])));
var dashKeyframes = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 0px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"])));
var Spinner = styled(SpinnerSVG)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  .Spinner {\n    animation: ", " ", "s linear infinite;\n    &__path {\n      stroke-dashoffset: 0;\n      stroke-dasharray: 80px, 200px;\n      animation: ", " ", "s ease-in-out infinite,\n        ", " ", "s ease-in-out infinite;\n    }\n  }\n"])), rotatorKeyframes, spinDuration, dashKeyframes, spinDuration, colorsKeyframes, spinDuration * 4);

export { Spinner };
